var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 16.791C5.4598 16.791 2.04199 13.3732 2.04199 9.16602C2.04199 4.95882 5.4598 1.54102 9.66699 1.54102C13.8742 1.54102 17.292 4.95882 17.292 9.16602C17.292 13.3732 13.8742 16.791 9.66699 16.791ZM9.66699 1.79102C5.59918 1.79102 2.29199 5.09821 2.29199 9.16602C2.29199 13.2338 5.59918 16.541 9.66699 16.541C13.7348 16.541 17.042 13.2338 17.042 9.16602C17.042 5.09821 13.7348 1.79102 9.66699 1.79102Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1786 18.48L17.1786 18.48L17.1712 18.479C17.0494 18.4635 16.8658 18.4132 16.6743 18.2592C16.4839 18.1063 16.2565 17.8274 16.0821 17.3081C15.9172 16.813 15.9874 16.36 16.2222 16.0336C16.4551 15.7098 16.8666 15.5 17.3913 15.5C18.1273 15.5 18.5798 15.777 18.7646 16.1313C18.9568 16.4996 18.9387 17.0351 18.5343 17.6382L18.5343 17.6382L18.533 17.6402C18.0299 18.3984 17.5414 18.4917 17.2996 18.4917C17.2706 18.4917 17.2335 18.4879 17.1786 18.48ZM18.328 17.5087L18.328 17.5087L18.3308 17.5046C18.4785 17.2856 18.5737 17.0735 18.6172 16.8744C18.6585 16.6857 18.6617 16.4645 18.5635 16.2681C18.4543 16.0498 18.2472 15.9267 18.073 15.8601C17.8829 15.7874 17.6529 15.75 17.3913 15.75C17.032 15.75 16.6676 15.8681 16.4357 16.1713L16.4299 16.1789L16.4244 16.1867C16.2007 16.5036 16.2121 16.9022 16.3255 17.234C16.4091 17.4885 16.5171 17.7035 16.6429 17.8682C16.7507 18.0092 16.9411 18.2039 17.2126 18.2378C17.4796 18.2712 17.711 18.1343 17.8503 18.0289C18.0144 17.9046 18.1767 17.7283 18.328 17.5087Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.aefb2b201794f0ed23813ec27bca6496.svg";
export { ForwardRef as ReactComponent };